function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FAFAFA;}\n\t.st2{fill:#E0E0E0;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#6C63FF;}\n\t.st6{fill:#0022F4;stroke:#000000;stroke-miterlimit:10;}\n\t.st7{font-family:'MyriadPro-Regular';}\n\t.st8{font-size:88px;}\n\t.st9{letter-spacing:2;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M832.9,158.2H401.5c-42.4,0-76.7,34.7-76.7,77.5v268.2c-0.1,20,16.1,36.3,36.1,36.4c0,0,0,0,0,0h274 c9.1,31.6,32,75.1,89.6,94.5l-16.3-94.5h124.7c20-0.1,36.2-16.4,36.1-36.4c0,0,0,0,0,0V194.6C869.1,174.6,852.9,158.3,832.9,158.2 C832.9,158.2,832.9,158.2,832.9,158.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M825.7,167.2H406.8c-41.1,0-74.5,33.4-74.5,74.5v257.8c0,19.3,15.7,35,35,35h266c8.8,30.3,31.1,72.2,87,90.8 l-15.8-90.8h121.1c19.3,0,35-15.7,35-35l0,0V202.3C860.6,182.9,845,167.3,825.7,167.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 500.8,
  y: 234.2,
  className: "st2",
  width: 216.5,
  height: 27.1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 634.8,
  y: 284.1,
  className: "st2",
  width: 81.2,
  height: 27.1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 554.7,
  y: 334.1,
  className: "st2",
  width: 160.1,
  height: 27.1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 517.2,
  y: 384,
  className: "st2",
  width: 196.3,
  height: 27.1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 608.8,
  y: 434,
  className: "st2",
  width: 103.5,
  height: 27.1
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M35.9,0h469.4c19.8,0,35.9,16.3,35.9,36.4v308.8c0,20.1-16.1,36.4-35.9,36.4H232.9c-9.1,31.5-31.9,75-89.1,94.3 l16.2-94.3h-124C16.1,381.6,0,365.3,0,345.2V36.4C0,16.3,16.1,0,35.9,0z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M41.3,9.5h458.2c19.3,0,35,15.7,35,35v297.3c0,19.3-15.7,35-35,35l0,0H233.6c-8.9,30.3-31.1,72.2-87,90.8 l15.8-90.8H41.3c-19.3,0-35-15.7-35-35V44.5C6.3,25.2,21.9,9.5,41.3,9.5C41.3,9.5,41.3,9.5,41.3,9.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 162.2,
  y: 66.6,
  className: "st5",
  width: 216.5,
  height: 27.1
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 163.4,
  y: 116.6,
  className: "st5",
  width: 81.2,
  height: 27.1
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 164.6,
  y: 166.5,
  className: "st5",
  width: 160.1,
  height: 27.1
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 165.9,
  y: 216.5,
  className: "st5",
  width: 196.3,
  height: 27.1
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 167.1,
  y: 266.4,
  className: "st5",
  width: 103.5,
  height: 27.1
});

var _ref17 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 116 523)",
  className: "st6 st7 st8 st9"
}, "Chat Application");

var SvgChat2 = function SvgChat2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x34_1468acd-cd3b-42a6-b6d6-962a1482835f",
    x: "0px",
    y: "0px",
    viewBox: "0 0 869 634.7",
    style: {
      enableBackground: "new 0 0 869 634.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.355,
    y1: -131.37,
    x2: 762.355,
    y2: 345.18,
    gradientTransform: "matrix(1 0 0 -1 -165.5 503.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.1099,
    y1: 27.43,
    x2: 436.1099,
    y2: 503.37,
    gradientTransform: "matrix(1 0 0 -1 -165.5 503.37)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat2.cff864d2.svg";
export { ForwardRef as ReactComponent };